export const onDialogEditDoneModel = model => ({
  widget: 'models',
  type: 'onDialogEditDoneModel',
  payload: { model },
})



// WEBPACK FOOTER //
// ./src/models/actions/onDialogEditDoneModel.js